function getLastNumericDigit(plate) {
  const digits = plate.match(/\d/g);
  if (!digits) {
    return null;
  }
  return parseInt(digits[digits.length - 1], 10);
}

export default getLastNumericDigit;
